import { memo, useContext } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import Timer from "app/pages/.shared/Timer";
import Badge from "app/pages/.shared/Badge";
import { productShape } from "app/utils/propTypes";
import get from "lodash/get";
import { isFlashsaleProduct } from "app/utils/utils";
import AppGlobalsContext from "app/AppGlobalsContext";
import { STRATEGY } from "app/constants";

const ProductTopBar = ({ product = {}, showSmartDPOnRootUrl }) => {
	const isFlashsale = isFlashsaleProduct(product);
	const { strategy } = useContext(AppGlobalsContext);

	return (
		<div className="product-top-bar">
			<Badge>
				{isFlashsale && (
					<Timer
						hour={get(product, "expiration.hour")}
						day={get(product, "expiration.day")}
						suffix={<FormattedMessage id="timer.left.label" />}
					/>
				)}
				{showSmartDPOnRootUrl && strategy !== STRATEGY.TRANSACTION_FIRST && (
					<div>
						<FormattedMessage id="sdp.only.for.member.badge.label" />
					</div>
				)}
			</Badge>
		</div>
	);
};

ProductTopBar.propTypes = {
	product: productShape,
	showSmartDPOnRootUrl: PropTypes.bool,
};

export default memo(ProductTopBar);
